import httpClient from '../httpClient';

export async function getAllKitDeProduto() {
  try {
    const response = await httpClient.get(`/api/kitproduto`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Kits DEPRODUTO: ' + error);
  }
}

export async function getAllKitDeProdutoPorProdutoId(id: string | number) {
  try {
    // Garante que o ID é um número válido antes de enviar para a API
    const produtoId = Number(id);
    if (isNaN(produtoId)) {
      throw new Error('ID do produto inválido');
    }

    const response = await httpClient.get(
      `/api/kitproduto/produtodaf/${produtoId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error(
      'Erro ao obter lista de Kits de Produtos por ID do Produto Farmacêutico: ' +
        error,
    );
  }
}

export async function getKitDeProduto(id: string) {
  try {
    const response = await httpClient.get(`/api/kitproduto/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Kit de Produtos: ' + error);
  }
}

export async function getProdutosDoKit(id: string) {
  try {
    const response = await httpClient.get(
      `/api/kitprodutodafmanytomany/kit/${id}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Produtos do Kit: ' + error);
  }
}

export async function getKitDeProdutoPorProdutoId(id: string) {
  try {
    const response = await httpClient.get(
      `/api/kitprodutodafmanytomany/produtoid/${id}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Kit de Produtos: ' + error);
  }
}

export async function getAllKitDeProdutoPorDenominacoId(id: string | number) {
  try {
    // Garante que o ID é um número válido antes de enviar para a API
    const denominacaoId = Number(id);
    if (isNaN(denominacaoId)) {
      throw new Error('ID da denominação genérica inválido');
    }

    const response = await httpClient.get(
      `/api/kitproduto/denominacao/${denominacaoId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error(
      'Erro ao obter lista de Kits de Produtos por ID da Denominação Genérica: ' +
        error,
    );
  }
}
